const STATIC_TEXT_QUESTION_REDUCER = (state, action) => state;

export {STATIC_TEXT_QUESTION_REDUCER}